import { useQuery } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { AcademyActivityByMonth } from '@ts-core/modules/billing/types';
import {
  getAcademyActivityByMonthQuery,
  GetAcademyActivityByMonthQueryResult,
  GetAcademyActivityByMonthQueryVariables,
} from '../graphql/queries/getAcademyActivityOverview';

export type AcademyActivityByMonthHookResult = DataFetcherHookResult<AcademyActivityByMonth, 'academyActivity'>;

export interface AcademyActivityByMonthHookInput {
  year: string;
  month: string;
}

export function useAcademyActivityByMonth(input: AcademyActivityByMonthHookInput): AcademyActivityByMonthHookResult {
  const { year, month } = input;
  const { data, loading, errorMessage } = useQuery<GetAcademyActivityByMonthQueryResult, GetAcademyActivityByMonthQueryVariables>(
    getAcademyActivityByMonthQuery,
    { variables: { year, month } }
  );

  return { loading, error: errorMessage, academyActivity: data?.academyActivity };
}
